// src/components/Navbar.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import "../styles/navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === "/";

  const navItems = [
    { href: "#hero", label: "Kezdőlap" },
    { href: "#services", label: "Szolgáltatások" },
    { href: "#about", label: "Rólunk" },
    { href: "#contact", label: "Kapcsolat" },
    { href: "#faq", label: "GYIK" },
  ];

  const handleNavClick = (href) => {
    if (!isHomePage) {
      navigate("/", { state: { scrollTo: href } });
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  return (
    <>
      <div
        className={`menu-overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      <div
        className={`container-fluid navbar-wrapper ${
          isHomePage ? "" : "navbar-light-bg"
        }`}
      >
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-dark px-3">
            <a
              href="/"
              className="navbar-brand navbar-brand-custom d-flex align-items-center"
            >
              <img
                src={isHomePage ? "/images/logo.png" : "/images/logoblack.png"}
                alt="Logo"
                className="navbar-logo me-2"
              />
              <span
                className={`logo-name ${isHomePage ? "" : "logo-name-black"}`}
              >
                Olajcsere Szolnok
              </span>
            </a>

            <button
              className={`custom-toggler d-lg-none ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              type="button"
              aria-label="Toggle navigation"
            >
              <span className="bar top-bar"></span>
              <span className="bar middle-bar"></span>
              <span className="bar bottom-bar"></span>
            </button>

            <div
              className={`collapse navbar-collapse animated-menu ${
                menuOpen ? "show" : ""
              }`}
              id="navbarResponsive"
            >
              <ul className="navbar-nav ms-auto text-center">
                {navItems.map((item, index) => (
                  <li className="nav-item mx-2 my-1" key={index}>
                    <button
                      className="nav-link navbar-link btn btn-link p-1"
                      onClick={() => handleNavClick(item.href)}
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Navbar;
